module.exports = __webpack_public_path__ + "static/media/ppg.e4a61c11.png";